<img ref="img" :src="src" :alt="alt">